module.exports = __webpack_public_path__ + "img/calendar.a54188bb.svg";